import { render, staticRenderFns } from "./orderbatchclose.vue?vue&type=template&id=9d2ace08&scoped=true&"
import script from "./orderbatchclose.vue?vue&type=script&lang=js&"
export * from "./orderbatchclose.vue?vue&type=script&lang=js&"
import style0 from "./orderbatchclose.vue?vue&type=style&index=0&id=9d2ace08&lang=scss&scoped=true&"
import style1 from "./orderbatchclose.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2ace08",
  null
  
)

export default component.exports